import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EventNavigationRoutingModule } from './event-navigation-routing.module';
import { EventNavComponent } from './layout/event-nav/event-nav.component';
import { EventNavViewComponent } from './layout/event-nav-view/event-nav-view.component';
// import { EventMenuComponent } from './layout/event-menu/event-menu.component';
import { EventDetailsComponent, SponsorVideoDialog } from './pages/event-details/event-details.component';
import { EventTicketsComponent, EventCheckoutDialog, UserAccountDialog } from './pages/event-tickets/event-tickets.component';
import { CoreModule } from 'src/app/core/core.module';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { EventScheduleComponent } from './pages/event-schedule/event-schedule.component';
import { EventHeaderComponent } from './pages/event-header/event-header.component';
import { ExpoStudioComponent } from './pages/expo/expo-studio/expo-studio.component';
import { ExpoDetailsComponent } from './pages/expo/expo-details/expo-details.component';
import { ContactDialogComponent } from './pages/expo/contact-dialog/contact-dialog.component';
import { ExpoListComponent } from './pages/expo/expo-list/expo-list.component';
import { PrivateChatComponent } from './pages/private-chat/private-chat.component';
import { NetworkingListComponent } from './pages/networking-list/networking-list.component';
import { NetworkRoomComponent } from './pages/network-room/network-room.component';
import { LoadAdsComponent } from './pages/load-ads/load-ads.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ClaimTicketComponent } from '../landing-pages/consumer/claim-ticket/claim-ticket.component';
import { ClaimTicketVerificationComponent } from '../landing-pages/consumer/claim-ticket-verification/claim-ticket-verification.component';
import { NetworkAdminComponent } from './pages/network-admin/network-admin.component';
import { EventMenuComponent } from './layout/event-menu/event-menu.component';

@NgModule({
  declarations: [
    EventNavComponent,
    EventNavViewComponent,
    // EventMenuComponent,
    EventDetailsComponent,
    EventTicketsComponent,
    ContactsComponent,
    SponsorVideoDialog,
    EventCheckoutDialog,
    // UserAccountDialog,
    EventScheduleComponent,
    EventHeaderComponent,
    ExpoStudioComponent,
    ExpoDetailsComponent,
    ContactDialogComponent,
    ExpoListComponent,
    PrivateChatComponent,
    NetworkingListComponent,
    NetworkRoomComponent,
    LoadAdsComponent,
    ClaimTicketComponent,
    ClaimTicketVerificationComponent,
    NetworkAdminComponent
  ],
  imports: [
    CommonModule,
    EventNavigationRoutingModule,
    CoreModule,
    CarouselModule.forRoot()
  ],
  exports: [EventMenuComponent, EventNavViewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventNavigationModule { }
